import React, { Fragment } from 'react'
import estilos from './TabsRecepcionMateriaPrima.module.css'
import PesadoDeAgaveFormComponent from '../Forms/PesadoDeAgaveFormComponent'
import CoccionFormComponent from '../Forms/CoccionFormComponent'
import MoliendaFormComponent from '../Forms/MoliendaFormComponent'
import FermentacionFormComponent from '../Forms/FermentacionFormComponent'
import DestilacionFormComponent from '../Forms/DestilacionFormComponent'
import ProcesosYEquipo from '../Forms/ProcesosYEquiposComponent'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import estilosgenerales from './TabsInspeccionarComponent.module.css'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { obtenerTodasLasRelacionesClientes } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import {
    obtenerAllGeneralInstalacionCliente, obtenerAllGeneralInstalacionClienteById,
    obtenerAllInstalacionesCliente, obtenerAllInstalacionesClienteById, obtenerAllResponsablesInstalacion,
    obtenerAllResponsablesInstalacionByInstalacion
} from '../../../../redux/DucksUnidadInspeccion/InstalacionDuck'

import { obtenerSolicitudDetalleFC_01, obtenerSolicitudDetalleFC_01ConMaps } from '../../../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';
import CuestionarioEnvasadoFormComponent from '../Forms/CuestionarioEnvasadoFormComponent'

function TabsRecepcionMateriaPrimaComponent(props) {
    const todo = props.detalles; // todo
    const instalacion = props.instalacion;
    const idinforme = props.idinforme;
    const verdaderaInstalacion = props.verdaderaInstalacion;

    //PRODUCCION
    const [tabUno, setTabUno] = React.useState(verdaderaInstalacion.idtipoanexo === 1 ? true : false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabCinco] = React.useState(false)

    //ENVASADO
    const [tabSeis, setTabSeis] = React.useState(verdaderaInstalacion.idtipoanexo === 2 ? true : false)
    const [tabSiete, setTabSiete] = React.useState(false)
    const [tabOcho, setTabOcho] = React.useState(false)

    //ALMACEN
    const [tabNueve, setTabNueve] = React.useState(verdaderaInstalacion.idtipoanexo === 3 ? true : false)
    const [tabDiez, setTabDiez] = React.useState(false)
    const [tabOnce, setTabOnce] = React.useState(false)

    const idanexo = useSelector(store => store.anexo.anexo);

    //VARIABLES QUE VAMOS A UTILIZAR:

    const fc01ConMap = useSelector(store => store.ModuloConsulta.fc01ConMap)
    const relacionesCliente = useSelector(store => store.ModuloConsulta.relacionesCliente)

    const dispatch = useDispatch()

    //PROBAR QUE TRAEN ESTAS VARIABLES
    const informacionGeneralInstalacionCliente = useSelector(store => store.Instalacion.informacionGeneralInstalacionCliente)
    const informacionGeneralInstalacionClienteById = useSelector(store => store.Instalacion.informacionGeneralInstalacionClienteById)

    const instalacionesCliente = useSelector(store => store.Instalacion.instalacionesCliente)
    const instalacionesClienteById = useSelector(store => store.Instalacion.instalacionesClienteById)

    const responsablesInstalacion = useSelector(store => store.Instalacion.responsablesInstalacion)
    const responsablesInstalacionById = useSelector(store => store.Instalacion.responsablesInstalacionById)

    React.useEffect(() => {
        dispatch(obtenerAllGeneralInstalacionCliente())
        dispatch(obtenerAllGeneralInstalacionClienteById(todo.idcliente))

        dispatch(obtenerAllInstalacionesCliente())
        dispatch(obtenerAllInstalacionesClienteById(todo.idcliente))

        dispatch(obtenerAllResponsablesInstalacion())
        dispatch(obtenerAllResponsablesInstalacionByInstalacion(todo.idcliente))

        dispatch(obtenerTodasLasRelacionesClientes(todo.idcliente))

        //dispatch(obtenerSolicitudDetalleFC_01ConMaps(todo.idcliente))
        //dispatch(obtenerSolicitudDetalleFC_01(todo.idcliente))

    }, [])

    //PRODUCCION
    const setearValoresUno = () => {
        irASeccion()
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresDos = () => {
        irASeccion()
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresTres = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresCuatro = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true); setTabCinco(false);
    }
    const setearValoresCinco = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(true);
    }

    //ENVASADO
    const setearValoresSeis = () => {
        irASeccion()
        setTabSeis(true); setTabSiete(false); setTabOcho(false);
    }
    const setearValoresSiete = () => {
        irASeccion()
        setTabSeis(false); setTabSiete(true); setTabOcho(false);
    }
    const setearValoresOcho = () => {
        irASeccion()
        setTabSeis(false); setTabSiete(false); setTabOcho(true);
    }

    //ALMACEN
    const setearValoresNueve = () => {
        irASeccion()
        setTabNueve(true); setTabDiez(false); setTabOnce(false);
    }
    const setearValoresDiez = () => {
        irASeccion()
        setTabNueve(false); setTabDiez(true); setTabOnce(false);
    }
    const setearValoresOnce = () => {
        irASeccion()
        setTabNueve(false); setTabDiez(false); setTabOnce(true);
    }

    React.useEffect(() => {

    }, [todo])

    const irASeccion = () => {
        const element = document.getElementById('inicioTabs');

        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Fragment>
            {
                verdaderaInstalacion.idtipoanexo === 1 ?
                    <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                        <div className={`col-3 text-center`}>
                            <button onClick={() => setearValoresUno()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabUno ? '#c88b3e' : 'transparent', color: tabUno ? 'white' : 'black' }}>Pesado de Maguey</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresDos()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabDos ? '#c88b3e' : 'transparent', color: tabDos ? 'white' : 'black' }}>Cocción</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresTres()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabTres ? '#c88b3e' : 'transparent', color: tabTres ? 'white' : 'black' }}>Molienda</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresCuatro()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabCuatro ? '#c88b3e' : 'transparent', color: tabCuatro ? 'white' : 'black' }}>Fermentación</button>
                        </div>
                        <div className={`col-3 text-center`}>
                            <button onClick={() => setearValoresCinco()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabCinco ? '#c88b3e' : 'transparent', color: tabCinco ? 'white' : 'black' }}>Destilación</button>
                        </div>
                    </div>
                    :
                    verdaderaInstalacion.idtipoanexo === 2 ?
                        <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                            {
                                //<div className={`col-3 text-center`}>
                                //    <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                //</div>
                            }
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Evaluación de la Conformidad</button>
                            </div>
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresSiete()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSiete ? '#c88b3e' : 'transparent', color: tabSiete ? 'white' : 'black' }}>Area de Envasado</button>
                            </div>
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresOcho()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabOcho ? '#c88b3e' : 'transparent', color: tabOcho ? 'white' : 'black' }}>Línea de Envasado Para Otros Productos Alcohólicos</button>
                            </div>

                        </div>
                        :
                        verdaderaInstalacion.idtipoanexo === 3 ?
                            <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                                {
                                    //<div className={`col-3 text-center`}>
                                    //    <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                    //</div>
                                }
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresNueve()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabNueve ? '#c88b3e' : 'transparent', color: tabNueve ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                </div>
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresDiez()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabDiez ? '#c88b3e' : 'transparent', color: tabDiez ? 'white' : 'black' }}>Almacén de Producto Terminado</button>
                                </div>
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresOnce()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabOnce ? '#c88b3e' : 'transparent', color: tabOnce ? 'white' : 'black' }}>Almacén de Maduración</button>
                                </div>

                            </div>
                            :
                            <div></div>
            }
            <hr />
            <div className='row'>
                <div className={`col-12 text-center`}>
                    {
                        tabUno ? (
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <PesadoDeAgaveFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme}></PesadoDeAgaveFormComponent>
                                <div className="col ">

                                </div>
                                <div className="col ">

                                </div>
                                <div className="col ">

                                </div>
                                <div className="col ">
                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDos()}>Ir a Cocción<ArrowForwardIcon /></button>
                                </div>
                                <div className="col ">
                                </div>
                            </div>
                        ) :
                            tabDos ? (
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <CoccionFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme}></CoccionFormComponent>

                                    <div className="col ">

                                    </div>

                                    <div className="col ">
                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresUno()}><ArrowBackIcon />Ir a Pesado de Maguey</button>
                                    </div>
                                    <div className="col ">
                                        <label className={`btn`}>Cocción </label>
                                    </div>
                                    <div className="col ">
                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresTres()}>Ir a Molienda<ArrowForwardIcon /></button>
                                    </div>

                                    <div className="col ">
                                    </div>
                                </div>
                            ) :
                                tabTres ? (
                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                        <MoliendaFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme}></MoliendaFormComponent>
                                        <div className="col ">

                                        </div>
                                        <div className="col ">
                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDos()}><ArrowBackIcon />Ir a Cocción</button>
                                        </div>
                                        <div className="col ">
                                            <label className={`btn`}>Molienda </label>
                                        </div>
                                        <div className="col ">
                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCuatro()}>Ir a Fermentación<ArrowForwardIcon /></button>

                                        </div>

                                        <div className="col ">

                                        </div>

                                    </div>
                                ) :
                                    tabCuatro ? (

                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                            <FermentacionFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme}></FermentacionFormComponent>
                                            <div className="col ">

                                            </div>
                                            <div className="col ">
                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresTres()}><ArrowBackIcon />Ir a Molienda</button>
                                            </div>
                                            <div className="col ">
                                                <label className={`btn`}>Fermentación </label>
                                            </div>
                                            <div className="col ">
                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCinco()}>Ir a Destilación<ArrowForwardIcon /></button>

                                            </div>
                                            <div className="col ">

                                            </div>
                                        </div>
                                    ) :
                                        tabCinco ? (

                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                <DestilacionFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme}></DestilacionFormComponent>
                                                <div className="col ">

                                                </div>
                                                <div className="col ">
                                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCuatro()}><ArrowBackIcon />Ir a Fermentación</button>
                                                </div>
                                                <div className="col ">
                                                    <label className={`btn`}>Fermentación </label>

                                                </div>
                                                <div className="col ">

                                                </div>
                                                <div className="col ">

                                                </div>
                                            </div>
                                        ) :
                                            tabSeis ? (

                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                    <CuestionarioEnvasadoFormComponent detalles={todo} instalacion={instalacion} idinforme={idinforme} verdaderaInstalacion={verdaderaInstalacion} />
                                                    <div className="col ">

                                                    </div>
                                                    <div className="col ">
                                                    </div>
                                                    <div className="col ">
                                                        <label className={`btn`}>Almacén de Producto a Granel </label>
                                                    </div>
                                                    <div className="col ">
                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSiete()}>Ir a Area de Envasado<ArrowForwardIcon /></button>

                                                    </div>
                                                    <div className="col ">

                                                    </div>
                                                </div>
                                            ) :
                                                tabSiete ? (

                                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                        <ProcesosYEquipo detalles={todo} instalacion={instalacion} idinforme={idinforme} idseccion={19} verdaderaInstalacion={verdaderaInstalacion} />
                                                        <div className="col ">

                                                        </div>
                                                        <div className="col ">
                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSeis()}><ArrowBackIcon />Ir a Almacén de Producto a Granel</button>
                                                        </div>
                                                        <div className="col ">
                                                            <label className={`btn`}>Area de Envasado </label>
                                                        </div>
                                                        <div className="col ">
                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresOcho()}>Ir a Otros Productos Alcohólicos<ArrowForwardIcon /></button>

                                                        </div>

                                                        <div className="col ">

                                                        </div>
                                                    </div>
                                                ) :
                                                    tabOcho ? (
                                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                            <ProcesosYEquipo detalles={todo} instalacion={instalacion} idinforme={idinforme} idseccion={19} verdaderaInstalacion={verdaderaInstalacion} otros={true} />
                                                            <div className="col ">

                                                            </div>
                                                            <div className="col ">
                                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSiete()}><ArrowBackIcon />Ir a Area de Envasado</button>
                                                            </div>
                                                            <div className="col ">
                                                                <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                            </div>
                                                            <div className="col ">

                                                            </div>
                                                            <div className="col ">

                                                            </div>
                                                        </div>
                                                    ) :
                                                        tabNueve ? (
                                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                <ProcesosYEquipo detalles={todo} instalacion={instalacion} idinforme={idinforme} idseccion={5} verdaderaInstalacion={verdaderaInstalacion} />
                                                                <div className="col ">

                                                                </div>
                                                                <div className="col ">
                                                                </div>
                                                                <div className="col ">
                                                                    <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                </div>
                                                                <div className="col ">
                                                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDiez()}>Ir a Area de Producto Terminado<ArrowForwardIcon /></button>
                                                                </div>
                                                                <div className="col ">

                                                                </div>
                                                            </div>
                                                        ) :
                                                            tabDiez ? (
                                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                    <ProcesosYEquipo detalles={todo} instalacion={instalacion} idinforme={idinforme} idseccion={11} verdaderaInstalacion={verdaderaInstalacion} />
                                                                    <div className="col ">

                                                                    </div>
                                                                    <div className="col ">
                                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresNueve()}><ArrowBackIcon />Ir a Area de Producto a Granel</button>
                                                                    </div>
                                                                    <div className="col ">
                                                                        <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                    </div>
                                                                    <div className="col ">
                                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresOnce()}>Ir a Area de Maduración<ArrowForwardIcon /></button>
                                                                    </div>
                                                                    <div className="col ">

                                                                    </div>
                                                                </div>
                                                            ) :
                                                                tabOnce ? (
                                                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                        <ProcesosYEquipo detalles={todo} instalacion={instalacion} idinforme={idinforme} idseccion={12} verdaderaInstalacion={verdaderaInstalacion} />
                                                                        <div className="col ">

                                                                        </div>
                                                                        <div className="col ">
                                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDiez()}><ArrowBackIcon />Ir a Area de Producto Terminado</button>
                                                                        </div>
                                                                        <div className="col ">
                                                                            <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                        </div>
                                                                        <div className="col ">

                                                                        </div>
                                                                        <div className="col ">

                                                                        </div>
                                                                    </div>
                                                                ) :
                                                                    <div></div>
                    }
                </div>
            </div>

        </Fragment>
    );
};


export default withRouter(TabsRecepcionMateriaPrimaComponent)